export default __webpack_public_path__ + "static/media/Blood Pressure disabled.d42a7155.svg";